import CognitoUserEdit from './abstract/CognitoUserEdit'
import Config from '../../../Config'

class CompanyUserEdit extends CognitoUserEdit {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.nameTitle = '氏名'
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRoleName = '会員企業ユーザ'
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
    this.parentUserRoleUrl = 'company'
  }
}

export default CompanyUserEdit



// WEBPACK FOOTER //
// ./src/admin/pages/secure/CompanyUserEdit.js